<template>
  <div class="page-wrapper">
    <project-requisites
        v-if="requisites.project_id"
        :requisites="requisites"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ProjectRequisites from '../components/ProjectRequisites/ProjectRequisites'

export default {
  name: 'ProjectRequisitesView',

  components: { ProjectRequisites },

  computed: {
    ...mapGetters({
      requisites: 'project/requisites',
    }),
  },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/views/ProjectRequisitesView.vue